import { backgroundJobsColumnValue } from '../pages/background-jobs'
import { setNotificationsByKeyThunk } from 'slices/notifications'
import { setJobsInfo } from 'slices/ui'
import client from 'api'
import moment from "moment"

export const setJobNotification = async(jobId: any, t: any, dispatch: any) => {
    const columnValue = backgroundJobsColumnValue(t)
    try {
        const { data } = await client.get(`/api/ixweb/protokoll/?hdr_id=${jobId}&action=eql`)
        const formatedDate = moment(data[0].HDR_H1_TIMESTAMP).format('DD.MM.YYYY')
        const processName = columnValue.taskType[data[0].AUFGABETYPE]
        const msg = `${processName} ${formatedDate}`
        dispatch(setJobsInfo({[data[0].HDR_ID]: {msg: msg, status:0}}))
        dispatch(setNotificationsByKeyThunk(
            [{
                type: 'job',
                msg: msg,
                name: 'job',
                expireTime: 60000,
                data: data[0]
            }],
            'background-jobs', false))
    } catch {
        return
    }
}
